import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'components/atoms/loader';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import BlockedSubscriptionRepresentant from 'components/molecules/blocked_subscription_representant';
import Documents from 'components/organisms/Documents';
import { ProportionalSale } from 'services/actions/proportional_sale';
import tabId from 'services/tabId';
import { ApplicationState } from 'store';
import { getInfoUser } from 'store/modules/my_account_store/actions';
import { getServiceSubscriptionStatus } from 'store/modules/service_subscription_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';
import { ServicesSubscriptionState } from 'store/modules/service_subscription_store/types';

const DocumentsService: React.FC = () => {
  const dispatch = useDispatch();

  const { profile, request } = useSelector<ApplicationState, ProfileState>(
    (state) => state.storage.profile,
  );
  const { servicesSubscriptions } = useSelector<ApplicationState, ServicesSubscriptionState>(
    (state) => state.storage.servicesSubscriptions,
  );
  const [dados, setDados] = useState<object | null>(null);

  useEffect(() => {
    dispatch(getInfoUser(profile?.id));
    dispatch(getServiceSubscriptionStatus(3, profile?.currentCompany[tabId()] || profile.clientId));

    const handleDocuments = async () => {
      const response = await ProportionalSale(10, [3]);
      if (response?.status === 200) {
        setDados(response.data);
      }
    };

    if (!servicesSubscriptions?.Documents?.current_signature && !profile.in_sample) {
      handleDocuments();
    }
  }, [
    dispatch,
    profile?.currentCompany,
    profile?.id,
    profile?.can_use_my_documents,
    profile?.in_sample,
    servicesSubscriptions?.Documents?.current_signature,
  ]);

  const renderContent = () => {
    if (request?.loading) {
      return <Loader />;
    }

    if (
      (!profile?.representant ||
        (profile?.representant && profile?.currentCompany[tabId()] === profile?.clientId)) &&
      profile?.paralyzed
    ) {
      return <BlockedSubscription paralyzed={profile?.paralyzed} />;
    }

    if (
      profile?.representant &&
      profile?.currentCompany[tabId()] !== profile?.clientId &&
      (profile?.represented?.filter(
        (company) => company?.id === profile?.currentCompany[tabId()],
      )[0]?.paralisado ||
        !servicesSubscriptions?.Documents?.current_signature)
    ) {
      return <BlockedSubscriptionRepresentant />;
    }

    if (
      (!profile?.representant && !profile?.paralyzed) ||
      (profile?.representant &&
        !profile?.represented?.filter(
          (company) => company.id === profile?.currentCompany[tabId()],
        )[0]?.paralisado)
    ) {
      return <Documents dados={dados} />;
    }

    return null;
  };

  return <div className="page-container">{renderContent()}</div>;
};

export default DocumentsService;
